import FlowNode from './FlowNode';
import FlowConnector from './FlowConnector';
import FlowBranch from './FlowBranch';
import AddStepButton from './AddStepButton';

/**
 * Renders a vertical chain of steps from the wing's steps array.
 * Handles linear flow and condition branching.
 */
export default function FlowCanvas({ steps, selectedNodeId, onNodeClick, onAddStep }) {
  if (!steps || steps.length === 0) {
    return (
      <div className="flex items-center justify-center py-20">
        <p className="text-text-secondary">No steps defined</p>
      </div>
    );
  }

  // Build a set of IDs that appear in condition branches (skip rendering them inline)
  const branchedIds = new Set();
  for (const step of steps) {
    if (step.type === 'condition') {
      if (step.trueBranch) branchedIds.add(step.trueBranch);
      if (step.falseBranch) branchedIds.add(step.falseBranch);
    }
  }

  // Render steps in order, skipping branched ones
  const mainFlow = steps.filter(s => !branchedIds.has(s.id));

  return (
    <div className="flex flex-col items-center py-6">
      {mainFlow.map((step, idx) => (
        <div key={step.id} className="flex flex-col items-center">
          {idx > 0 && (
            <>
              <FlowConnector />
              <AddStepButton onAdd={(type) => onAddStep(type, idx)} />
              <FlowConnector />
            </>
          )}

          <FlowNode
            step={step}
            selected={selectedNodeId === step.id}
            onClick={onNodeClick}
          />

          {/* Render branch if this is a condition step */}
          {step.type === 'condition' && (step.trueBranch || step.falseBranch) && (
            <FlowBranch
              conditionStep={step}
              steps={steps}
              selectedNodeId={selectedNodeId}
              onNodeClick={onNodeClick}
            />
          )}
        </div>
      ))}

      {/* Add step at the end (before last if last is exit) */}
      <FlowConnector />
      <AddStepButton onAdd={(type) => onAddStep(type, mainFlow.length)} />
    </div>
  );
}
